import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { cnpjMask, cpfMask } from '../../shared/mask';

function ReportEmpresas({ dados }) {

    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState();
    const [titleModal, setTitleModal] = useState('');
    // const [docreport, setDocreport] = useState('');
    const { state } = useLocation();

    useEffect(() => {
        // let doc = state[0].doc_number.length === 14 ? cnpjMask(state[0].doc_number) : cpfMask(state[0].doc_number)
        // setDocreport(doc);
    }, []);

    const handleClickInfo = (data, title, index) => {
        setActiveData(data);
        setTitleModal(title);
        setShowModal(true);
    }

    return (
        <>
            <Row className='scrollbar d-flex' style={{ height: 'calc(100vh - 480px)' }}>
                {dados['Empresas dos Sócios'] && dados['Empresas dos Sócios'].map((item, index) =>
                
                    <Col key={item + index} md={4}>
                        <div className='rect-content-risks' style={{ height: '116px' }}>
                            <p className='two-rows'><b>Nome: </b> {item.Nome}</p>
                            {item.CNPJ ? <p><b>CNPJ: </b> {cnpjMask(item.CNPJ)}</p> : <p><b>CPF: </b> {item.CPF}</p>}
                            {Array.isArray(item['CNPJs Vinculados']) && item['CNPJs Vinculados'].length > 0 && 
                                <div className='rect-link cursor-pointer' style={{ top: '65px' }} onClick={() => handleClickInfo(item['CNPJs Vinculados'], 'CNPJs Vinculados')}><i className="bi bi-plus-circle-fill"></i></div>
                            }
                        </div>
                    </Col>

                )}
                

                {
                    (!dados['Empresas dos Sócios']) ? 
                    <Row><span className="fs-6">Não foram identificadas "Empresas dos Sócios"</span></Row> : null
                }
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes - Empresas dos Sócios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData && (
                        <>
                            <p className='rect-tx-1 fs-5' title={titleModal}>{titleModal}</p>
                            {activeData && activeData.length > 0 && activeData.map((item, i) => (
                                <div key={item + i} className='mb-5'>
                                    {item && Object.keys(item).length > 0 && Object.keys(item).map((key, i) => (
                                        key === 'Razão Social' || key === 'CNPJ da Matriz' ? <div key={key + i} className='mb-2 color-tertiary'><b>{key}</b>: {item[key]}</div> :
                                            <div key={key + i}><b>{key}</b>: {item[key]}</div>
                                    ))}
                                </div>
                            ))}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportEmpresas;